<template>
	<div>
		<!-- 顶部显示的页面 -->
		<el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:10px">
			<el-breadcrumb-item>券统计</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 新增套餐的按钮 -->
		<div>
			<el-radio-group v-model="type" @change="changeType">
				<el-radio-button v-for="v in types" :label="v.label">{{v.value}}</el-radio-button>
			</el-radio-group>
		</div>
		<div style="margin-top:20px">
			<el-table :data="tableList" style="width: 100%" v-loading="loading" element-loading-text="拼命加载中">
				<el-table-column label="店铺数量" prop="shop_num"/>
				<el-table-column label="券包总数" prop="package_num"/>
				<el-table-column label="卖出数量" prop="use_num"/>
				<el-table-column label="利润" prop="my_money"/>
        <el-table-column label="总金额" prop="total_money"/>
			</el-table>
		</div>
		<!-- 分页 -->
<!--		<div>-->
<!--			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"-->
<!--						   :current-page="currentPage" :page-sizes="[10, 20, 30, 40]"-->
<!--						   :page-size="pageSize" layout="total,  prev, pager, next, jumper"-->
<!--						   :total="total"-->
<!--						   style="text-align:right;margin:0 16px 10px 0;border-radius:20px"></el-pagination>-->
<!--		</div>-->
	</div>
</template>

<script>
import qs from "qs";
import coupon from "../api/coupons";

export default {
	props: {
		pageSize: {
			type: Number,
			default: 10
		}
	},
	data() {
		return {
			loading: true,
			types:[{label:'year',value:'本年'},{label:'month',value:'本月'},{label:'week',value:'本周'},{label:'day',value:'本日'}],
			currentPage: 1,   //分页
			total: 0,        //分页
			tableList: [],
			type:'year',
			area_id:''
		}
	},
	mounted() {
		let query = this.$route.query,id;
		if(query.id){
			id=query.id;
		}else {
			id=qs.parse(sessionStorage.getItem("userData")).area_id;
		}
		this.area_id=id;
		this.getAreaCountData();
	},
	filters: {
	},
	methods: {
		getAreaCountData(type='year') {
			coupon.getAreaCountData({area_id:this.area_id,type}).then(res => {
        this.tableList=[res];
			}).finally(res=>{this.loading=false;})
		},
		changeType(val){
		  this.loading=true;
			this.getAreaCountData(val);
		},
		// 分页
		handleSizeChange(val) {
			this.queryList.pageSize = val;
			this.getCouponPackageList();
		},
		handleCurrentChange(val) {
			this.queryList.pageindex = val;
			this.getCouponPackageList();
		},
	},
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/statistics.vue